import { callApi } from '../../libs'

const cancelOrder = async (orderNumber) => {
    return new Promise(async (resolve, reject) => {
        const url = `${process.env.REACT_APP_API_COVID19}/api/orders/cancel`
        const method = 'put'
        const body = { orderNumber }
        try {
            const response = await callApi(method, url, body, null)
            resolve(response)
        } catch (error) {
            reject(error)
        }
    })
}

export default cancelOrder

